module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "mb10"
  }, [_c('el-button', {
    staticClass: "mb10",
    attrs: {
      "type": "primary",
      "size": "normal"
    },
    on: {
      "click": _vm.toCert
    }
  }, [_vm._v("新增运动员备案\n        ")])], 1), _vm._v(" "), _c('el-table', {
    ref: "table",
    attrs: {
      "data": _vm.list,
      "row-key": "id",
      "show-header": false
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "报名会议",
      "fixed": "left",
      "prop": "title"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(scope.row.num))]), _vm._v(" "), _c('p', {
          staticClass: "gray-light"
        }, [_vm._v("性别:" + _vm._s(scope.row.sex == 1 ? '男' : '女') + " 手机:" + _vm._s(scope.row.phone))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "prop": "zhuantai"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 2) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v(" 审核成功\n            ")]) : _c('el-tag')]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "日期",
      "prop": "riqi"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm._f("timeFormat")(scope.row.create_time)) + "\n          ")]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": parseInt(_vm.row.currentpage),
      "page-size": _vm.params.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.row.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a91989b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/skill/AbilityApplyMemberList.vue
// module id = 1470
// module chunks = 0